import { customAxios } from "./serviceInterceptor";
import { getAPIPath } from "../utils/endPointMapper";

const API_URL = getAPIPath().REACT_APP_BASE_URL;

export const AU_TRADING_INFO_MOCK = {
    "processName": "updateUser",
   "requestBody": {
        "users": [
            {
                "tradingInfo": {
                    "purposeOfAccount": {
                        "english": {
                            "title": "Your trading goal"
                        },
                        "locale": {
                            "title": "Your trading goal"
                        }
                    },
                    "values": {
                        "purposeOfAccount": null,
                    },
                    "tradingCfd": {
                        "english": {
                            "title": "How were you educated on our products? (Spread bets and CFDs)"
                        },
                        "locale": {
                            "title": "How were you educated on our products? (Spread bets and CFDs)"
                        }
                    },
                    "noOfTradedCFD": {
                        "english": {
                            "title": "How many spread bet, CFDs or leveraged FX trades, on average, have you placed per month over the last 3 years (non-advised only)?"
                        },
                        "locale": {
                            "title": "How many spread bet, CFDs or leveraged FX trades, on average, have you placed per month over the last 3 years (non-advised only)?"
                        }
                    }
                }
            }
        ]
    },
    "message":"skipTradingInfo",
    "methodType": "POST",
    "serviceName": [
        "tradingInfo"
    ]
};

export const submitSkipTradingInfo = async (config) => {
    customAxios.post(API_URL, AU_TRADING_INFO_MOCK, config);
}

